import { Link } from 'react-router-dom';
import { getHotComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function HotComics() {
  const hotComics = getHotComics(8);

  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16" aria-labelledby="hot-comics-title">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 id="hot-comics-title" className="text-xl md:text-2xl font-heading text-foreground-900 tracking-wide">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">千万读者的共同选择，人气爆棚的漫画都在这里</p>
        </div>
        <Link
          to="/category/rexue"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
        >
          查看全部
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
        {hotComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}